import { type AdditionalSettingsType, type Params, isParamsValid } from 'app/dataTypes/dishes/additionalSettings'

import { useCommonDataProvider, Options } from 'app/dataProviders/useCommonDataProvider'
import { GET_ADDITIONAL_SETTINGS, convertResult, convertParams } from 'app/common/api/requests/food/items/additional_settings/get'


const defaultState: AdditionalSettingsType = {
  disableForTerminalGuestSales: false
}

type Op = Omit<Options<
  AdditionalSettingsType,
  Params
>, 'requestValue' | 'convertions' | 'defaultState'>

export function useAdditionalSettings(options: Op = {} as Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_ADDITIONAL_SETTINGS,
    error: 'Не удалось получить дополнительные настройки',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
    isParamsValid,
  })

  return res
}
